export default {"ageRestriction":"W1nBw","visible":"KcfH3","content":"dc1an","accept":"DZV-e"};